// extracted by mini-css-extract-plugin
export default {"Container":"WithDrawalPopup_Container__DGtX6","heading":"WithDrawalPopup_heading__+ehFR","input":"WithDrawalPopup_input__8OPro","btn":"WithDrawalPopup_btn__gPcK6"};